<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.smAndDown"
    v-model="dialog"
    @keydown.esc="cancel"
    :max-width="$vuetify.breakpoint.smAndDown ? 'none' : '600px'"
    content-class="fullscreen-dialog"
    persistent
  >
    <v-card class="dialog-card">
      <v-toolbar color="primary" dense class="header primaryText--text">
        <v-row>
          <v-col cols="2" align-self="end">
            <v-btn text @click="close(false)">{{ $t("close") }}</v-btn>
          </v-col>

          <v-col cols="8" class="d-flex justify-center align-center">
            <div>
              <v-toolbar-title
                class="header-title1"
                v-if="$appMode == 0 && $store.state.store != null && $store.state.store.info != null"
                >{{ $store.getters.storeName }}</v-toolbar-title
              >
              <v-toolbar-title class="header-title2">{{ $t("login") }}</v-toolbar-title>
            </div>
          </v-col>

          <v-col cols="2" align-self="end" style="text-align:right"></v-col>
        </v-row>
      </v-toolbar>

      <!-- <v-card-title class="mx-12 mt-4">{{ $t("member_login") }}</v-card-title> -->

      <v-card-text>
        <v-form v-model="valid" ref="form">
          <v-container>
            <v-list-item>
              <v-text-field
                ref="phone"
                v-model="phone"
                :rules="[inputRules.required, inputRules.phone]"
                :label="$t('mobile_no')"
                :placeholder="$t('login_with_mobile')"
                required
                @keyup.enter="login"
              ></v-text-field>
            </v-list-item>  

            <div class="text-center mt-2 px-4 font-weight-bold">
              {{ $t("sms_receive_vcode") }}
            </div>                     

            <div v-show="message != null && message != ''" class="text-center mt-8">
              {{ message }}
            </div>

            <v-btn class="horizontal-center login-button" :disabled="!valid" @click="login">{{ $t("login") }}</v-btn>
             
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,

    message: null,
    valid: false,
    phone: "",
  }),

  methods: {
    open(message) {
      this.message = this.$t("login.to_continue");
      if (message != null && message != "") this.message = message;

      this.dialog = true;

      setTimeout(() => {
        if (this.$refs.phone != null)
          this.$refs.phone.focus();
      }, 100);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close(result) {
      this.$refs.form.reset();
      this.dialog = false;
      this.resolve(result);
    },

    async login() {
      if (!this.valid) return;

      let phoneID = "+1" + this.phone.replace(/\D+/g, "");

      let lastLogin = {
        name: "",
        phone1: phoneID.substring(2),
        isMember: true,
      };

      let isVerifiedPhoneNumber = await this.isVerifiedPhoneNumber(phoneID);
      if (!isVerifiedPhoneNumber) {
        isVerifiedPhoneNumber = await this.$root.phoneVerificationDialog(phoneID);
        if (isVerifiedPhoneNumber) {
          this.addVerifiedPhoneNumber(phoneID);
        }
      }

      if (isVerifiedPhoneNumber) {
        console.log("getting member");

        this.rest_getMember(phoneID).then(memberResp => {
          console.log(memberResp);
          if (memberResp.result == "ok") {
            this.$store.state.member = memberResp.record.child;
            this.setLastLogin(lastLogin);
            this.updateOrderLogin(true);

            let memberCode = this.$store.state.member.MemberCode;
            this.updateMemberPromos(memberCode);

            if (memberResp.new || this.$store.state.member.MemberFirstName == "") {
              this.$root.memberProfileDialog(this.$store.state.member).then(resp => {
                if (resp) {
                  this.rest_getMember(phoneID).then(n_memberResp => {
                    if (n_memberResp.result == "ok") {
                      this.close(true);
                    } else {
                      this.$root.messageDialog(this.$t("error_alert_title"), "", n_memberResp.result);
                    }
                  });
                }
              });
            } else {
              this.close(true);
            }
          } else {
            this.$root.messageDialog(this.$t("error_alert_title"), "", memberResp.result);
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-button {
  margin-top: 10px;

  background-color: var(--v-primary-base) !important;
  color: var(--v-primaryText-base) !important;
}

.theme--light.v-btn.v-btn--disabled.login-button {
  background-color: var(--v-primary-base) !important;
  color: var(--v-primaryText-base) !important;
}
</style>
